import { useState } from "react";
import { api } from "../lib/api";

export default function ChangePasswordModal({ onClose }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState({ type: "", text: "" });

  const submit = async (e) => {
    e.preventDefault();
    setMsg({ type: "", text: "" });
    if (next !== confirm) {
      setMsg({ type: "err", text: "New password and confirmation don't match" });
      return;
    }
    setBusy(true);
    try {
      await api.changeMyPassword(cur, next);
      setMsg({ type: "ok", text: "Password updated. You can keep using the app." });
      setCur(""); setNext(""); setConfirm("");
    } catch (err) {
      setMsg({ type: "err", text: err.response?.data?.detail || err.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" style={{ maxWidth: 460 }}
           onClick={(e) => e.stopPropagation()}
           data-testid="changepw-modal">
        <div className="modal-head">
          <h2>Change your password</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <form className="modal-form" onSubmit={submit}>
          <div className="form-field">
            <label>Current password</label>
            <input type="password" value={cur} required
              onChange={(e) => setCur(e.target.value)} data-testid="cpw-current" />
          </div>
          <div className="form-field">
            <label>New password (≥ 6 chars)</label>
            <input type="password" value={next} required minLength={6}
              onChange={(e) => setNext(e.target.value)} data-testid="cpw-new" />
          </div>
          <div className="form-field">
            <label>Confirm new password</label>
            <input type="password" value={confirm} required minLength={6}
              onChange={(e) => setConfirm(e.target.value)} data-testid="cpw-confirm" />
          </div>
          {msg.text && (
            <div
              className={msg.type === "ok" ? "form-ok" : "form-error"}
              style={{ marginTop: 6 }}
              data-testid="cpw-msg"
            >{msg.text}</div>
          )}
          <div className="modal-actions">
            <button type="button" className="btn-ghost" onClick={onClose}>Close</button>
            <button type="submit" className="btn-primary"
              disabled={busy || !cur || !next || !confirm}
              style={{ width: "auto", padding: "10px 22px", margin: 0 }}
              data-testid="cpw-submit"
            >{busy ? "Saving…" : "Update password"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
